import { faFacebook, faInstagram, faLinkedinIn, faXTwitter } from '@fortawesome/free-brands-svg-icons'
import { faBoxOpen, faBuilding, faEnvelope, faHandsHelping, faMapMarkerAlt, faStore } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useRef } from 'react'
import Carousel from './Carousel';
import FAQSection from './FAQSection';
import BusinessShowcase from './BusinessShowcase';
import { Link } from 'react-router-dom';


function Landingpage() {
  const whyUsRef = useRef(null);

  const handleScroll = () => {
    whyUsRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <div className='bg-[#ffffff]'>

      {/* landing card */}
      <div className="relative h-screen">
        {/* <img className="w-full absolute left-0 right-0 h-screen sm:h-[600px] md:h-[700px] lg:h-[800px] object-cover pt-0  md:pl-32  md:pr-20 rounded-2xl" src="images/landin8.jpeg" alt="Background" /> */}
        <Carousel/>
        <div className="absolute xl:left-10 top-[45%] transform -translate-y-1/2 bg-[#55B949] p-9 rounded-tr-md rounded-br-md max-w-md xl:max-w-3xl h-[400px]  items-center  justify-center w-full ">
          <p className="text-xl md:text-3xl xl:text-5xl font-semibold text-white font-Rubik text-center "> Refrigeration Solutions for your Business</p>
          <p className="text-sm md:text-lg xl:text-2xl text-zinc-300  text-justify font-Rubik mt-8">
          From compact coolers to industrial-grade systems, we offer innovative refrigeration solutions that optimize performance and reduce energy costs for businesses of all sizes
          </p>
          <div className='mt-6 flex justify-center'>
          <button onClick={handleScroll} className=' text-xl font-semibold bg-white text-black hover:bg-black hover:text-white p-2 w-40'>Explore</button>
        </div>
        </div>
      </div>

  {/* <!-- Why Us --> */}
      <div ref={whyUsRef} class="max-w-7xl mx-auto px-4  ">
  <div class="text-center mb-12">
    <h2 class="text-4xl md:text-6xl xl:text-8xl font-bold text-gray-800 mb-4">Why Us</h2>
  </div>

  {/* <!-- First Row of Subheadings --> */}
  <div class="grid grid-cols-1 md:grid-cols-2 gap-8 text-center mb-12">
    <div>
      <h3 class="text-2xl md:text-4xl text-gray-800 mb-4 font-bold">What We Do</h3>
      <p class="text-lg md:text-xl text-gray-600">
        We specialize in providing high-quality tailored refrigerated equipment & display that enhances your product display and preserves freshness.
      </p>
    </div>

    <div>
      <h3 class="text-2xl md:text-4xl  text-gray-800 mb-4 font-bold">Our Experiences</h3>
      <p class="text-lg md:text-xl text-gray-600">
        With years of industry experience, we understand the unique challenges businesses face and offer expert solutions to meet them.
      </p>
    </div>
  </div>

  {/* <!-- Second Row of Subheadings --> */}
  <div class="grid grid-cols-1 md:grid-cols-2 gap-8 text-center mb-12">
    <div>
      <h3 class="text-2xl md:text-4xl  text-gray-800 mb-4 font-bold">Our Solutions</h3>
      <p class="text-lg md:text-xl text-gray-600">
        We provide innovative, durable, and efficient bakery equipment designed to optimize your operations and display.
      </p>
    </div>

    <div>
      <h3 class="text-2xl md:text-4xl text-gray-800 mb-4 font-bold">Customer Satisfaction</h3>
      <p class="text-lg md:text-xl text-gray-600">
        We prioritize customer satisfaction by offering personalized solutions and continuous support to ensure long-term success.
      </p>
    </div>
  </div>
</div>

<BusinessShowcase/>

      <div className="max-w-7xl mx-auto pt-20 pb-20   px-4">
  <div className="flex items-center justify-center">
    <span className="flex-grow h-[2px] bg-black"></span>
    <p className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold mx-4 whitespace-nowrap text-center">
      Benefits you get when<br/> using our Solutions
    </p>
    <span className="flex-grow h-[2px] bg-black"></span>
  </div>
</div>

      {/* icons & texts */}
      <div className='flex flex-wrap justify-center gap-10 md:gap-20 p-4'>
        <div className='text-center max-w-sm'>
          <FontAwesomeIcon icon={faBuilding} className='w-12 h-12 text-black mb-4' />
          <p className='text-xl md:text-4xl font-bold'>Our Solutions</p>
          <p className='text-sm md:text-xl sm:text-center text-zinc-400 mt-4'>
            We offer top-quality equipment for coffee shops, bakeries, supermarkets, and retail stores to help you achieve success.
          </p>
        </div>
        <div className='text-center max-w-sm'>
          <FontAwesomeIcon icon={faBoxOpen} className='w-12 h-12 text-black mb-4' />
          <p className='text-xl md:text-4xl sm:text-2xl font-bold'>Explore Our Products</p>
          <p className='text-sm md:text-xl mt-4 sm:text-center text-zinc-400 '>
            Discover our range of innovative products designed to meet your unique business needs.
          </p>
        </div>
        <div className='text-center max-w-sm'>
          <FontAwesomeIcon icon={faHandsHelping} className='w-12 h-12 text-black mb-4' />
          <p className='text-xl md:text-4xl sm:text-2xl font-bold'>Get Help</p>
          <p className='text-sm md:text-xl sm:text-center text-zinc-400 mt-4'>
            Need assistance? Our expert support team is here to guide you every step of the way.
          </p>
        </div>
      </div>

      <div className='flex flex-col lg:flex-row justify-center gap-8 sm:gap-16 2xl:gap-32 items-center lg:pt-20'>
        <div className='mt-16 sm:mt-20 md:mt-32'>
          <img className='w-full   h-[500px] sm:h-[600px] xl:w-[600px] lg:h-[450px] lg:w-[400px] 2xl:w-[700px] object-full' src='images/landsolu2.png' alt='Model' />
        </div>
        <div className='flex flex-col gap-6 p-3 sm:gap-8 max-w-lg'>
          <p className='text-2xl sm:text-4xl xl:text-6xl font-bold'>We provide you the best equipment</p>
          <p className='text-lg sm:text-2xl xl:text-2xl'>
            Our commitment to innovation is reflected in the cutting-edge technology we incorporate into our products. From automated systems to energy-saving features,
          </p>
          <div className='flex justify-center lg:justify-start'>
            <button className='text-xl font-bold border border-black w-48 sm:w-60 p-2 hover:bg-black hover:text-white'>
              <Link to="/mainhomemodel" className="block  font-mono">
              Explore More
              </Link>
            </button>
          </div>
        </div>
      </div>

      {/* image & text */}
      <div className="flex flex-col lg:flex-row justify-center items-center gap-8 sm:gap-12 lg:gap-16 mx-4 md:mx-16 mt-16 mb-20 xl:mt-32 lg:pt-20">
        <div className="flex flex-col justify-center items-start gap-12 sm:gap-16 md:gap-8">
          <div className="flex flex-col md:flex-row items-center gap-4 sm:gap-6">
            <div className="flex items-center justify-center w-10 sm:w-12 h-10 sm:h-12 rounded-full bg-black text-white font-bold">1</div>
            <div className="max-w-xs sm:max-w-sm">
              <p className="text-xl sm:text-2xl lg:text-4xl font-bold">Best Quality</p>
              <p className="text-justify lg:text-lg mt-3 text-zinc-400">
                Our commitment to innovation is reflected in the cutting-edge technology we incorporate into our products. From automated systems to energy-saving features.
              </p>
            </div>
          </div>

          <div className="flex flex-col md:flex-row items-center gap-4 sm:gap-6">
            <div className="flex items-center justify-center w-10 sm:w-12 h-10 sm:h-12 rounded-full bg-black text-white font-bold">2</div>
            <div className="max-w-xs sm:max-w-sm">
              <p className="text-xl sm:text-2xl lg:text-4xl font-bold">Excellence</p>
              <p className="text-justify text-zinc-400 lg:text-lg mt-3">
                Our commitment to innovation is reflected in the cutting-edge technology we incorporate into our products. From automated systems to energy-saving features.
              </p>
            </div>
          </div>

          <div className="flex flex-col md:flex-row items-center gap-4 sm:gap-6">
            <div className="flex items-center justify-center w-10 sm:w-12 h-10 sm:h-12 rounded-full bg-black text-white font-bold">3</div>
            <div className="max-w-xs sm:max-w-sm">
              <p className="text-xl sm:text-2xl lg:text-4xl font-bold">Best Solutions</p>
              <p className="text-justify text-zinc-400 lg:text-lg mt-3">
                Our commitment to innovation is reflected in the cutting-edge technology we incorporate into our products. From automated systems to energy-saving features.
              </p>
            </div>
          </div>
        </div>
        <div className="">
          <img className="w-full lg:h-[500px] xl:w-[600px] 2xl:w-[700px]" src="images/landsolu3.webp" alt="Model" />
        </div>
      </div>


<FAQSection/>

      {/* Newsletter Section */}
      {/* <div className="flex  justify-center items-center mt-16  mb-20">
        <div className="text-center bg-white p-8 rounded-lg shadow-lg max-w-6xl w-full">
          <p className="text-2xl sm:text-3xl xl:text-4xl font-bold mb-4">Subscribe to get the Latest news about Us</p>
          <p className="text-sm sm:text-md xl:text-xl text-gray-600 mb-6">
            Stay updated with our latest offers, updates, and exclusive news. Don't miss out on any exciting announcements!
          </p>

          <div className="flex flex-col md:flex-row rounded-lg border border-gray-300 p-2 justify-around items-center gap-4">
            <input
              type="email"
              placeholder="Enter your email"
              className="px-8 sm:px-12 text-sm sm:text-lg"
            />
            <button className="bg-gray-500 text-white px-6 py-3 rounded-lg hover:bg-gray-600 w-32 sm:w-40">
              Subscribe
            </button>
          </div> 
        </div>
      </div> */}
    </div>
  );
}

export default Landingpage;
